<template>

	<span>

		<span aria-hidden="true" :class="'icon-'+icon">

			<span :class="'path'+index" v-for="(path, index) in paths" :key="index"></span>

			<slot></slot>
			
		</span>

	</span>

</template>

<script lang="ts">

	import { Options, Vue } from 'vue-class-component';

	@Options({
		props: {
			icon: {
				type: String
			},
			paths: {
				type: Number,
				default: 0
			},
		}
	})
	export default class Icon extends Vue
	{
	}

</script>

<style lang="scss" scoped>

@font-face
{
	font-family: icons;
	src: url(/src/fonts/icons.ttf);
}

[class^="icon-"], [class*=" icon-"]
{
	/* use !important to prevent issues with browser extensions that change fonts */
	font-family: 'icons' !important;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
  
	/* Better Font Rendering =========== */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.icon {
    font-family: 'custom-font';
    font-size: 100px;
    margin: 10px;
}

.icon-amazon-music:before {
    content: "\e000";
}

.icon-apple-music:before {
    content: "\e001";
}

.icon-beatport:before {
    content: "\e002";
}

.icon-deezer:before {
    content: "\e003";
}

.icon-discord:before {
    content: "\e004";
}

.icon-facebook:before {
    content: "\e005";
}

.icon-hardstyle-com:before {
    content: "\e006";
}

.icon-hardtunes:before {
    content: "\e007";
}

.icon-instagram:before {
    content: "\e008";
}

.icon-itunes:before {
    content: "\e009";
}

.icon-qdance-next:before {
    content: "\e00a";
}

.icon-qdance:before {
    content: "\e00b";
}

.icon-rapture-records:before {
    content: "\e00c";
}

.icon-soundcloud:before {
    content: "\e00d";
}

.icon-spotify:before {
    content: "\e00e";
}

.icon-youtube-music:before {
    content: "\e00f";
}

.icon-youtube:before {
    content: "\e010";
}

</style>